module.exports = __webpack_public_path__ + "img/pack.d2500989.png";